import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'elvis-backdrop';

/**
 * Bakgrundsbilden är ett personligt val och sparas per webbläsare, precis som
 * hopfälld sidomeny. Av som standard — 2.0 är byggt för den rena grunden, och
 * bilden ska vara något man aktivt väljer till.
 *
 * Attributet sätts på <body> i stället för på ett React-element, eftersom
 * grundfärgen som ska bort ligger där.
 */
export function useBackdrop() {
  const [enabled, setEnabled] = useState<boolean>(() => {
    if (typeof localStorage === 'undefined') return false;
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(enabled));
    if (typeof document === 'undefined') return;
    if (enabled) {
      document.body.dataset.backdrop = 'on';
    } else {
      delete document.body.dataset.backdrop;
    }
  }, [enabled]);

  // Städa vid avmontering så att attributet inte lever kvar på inloggningssidan
  useEffect(() => {
    return () => {
      if (typeof document !== 'undefined') delete document.body.dataset.backdrop;
    };
  }, []);

  const toggle = useCallback(() => setEnabled((v) => !v), []);

  return { enabled, toggle };
}
